"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Chip_1 = __importDefault(require("./Chip"));
var Chips_less_1 = __importDefault(require("./Chips.less"));
var SCROLL_THRESHOLD = 1;
var Chips = (0, react_1.memo)(function (_a) {
    var options = _a.options, selected = _a.selected, onSelect = _a.onSelect;
    var ref = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)('left'), scrollPosition = _b[0], setScrollPosition = _b[1];
    (0, react_1.useEffect)(function () {
        var _a;
        var onScroll = function (_a) {
            var target = _a.target;
            var _b = target, scrollLeft = _b.scrollLeft, scrollWidth = _b.scrollWidth, offsetWidth = _b.offsetWidth;
            var position = (scrollLeft - SCROLL_THRESHOLD) <= 0 ? 'left' :
                (scrollLeft + offsetWidth + SCROLL_THRESHOLD) >= scrollWidth ? 'right' :
                    'center';
            setScrollPosition(position);
        };
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', onScroll);
        return function () { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', onScroll); };
    }, []);
    return (react_1.default.createElement("div", { ref: ref, className: (0, classnames_1.default)(Chips_less_1.default['chips'], [Chips_less_1.default[scrollPosition]]) }, options.map(function (_a) {
        var label = _a.label, value = _a.value;
        return (react_1.default.createElement(Chip_1.default, { key: value, label: label, value: value, active: selected.includes(value), onSelect: onSelect }));
    })));
});
exports.default = Chips;
